// extracted by mini-css-extract-plugin
module.exports = {"B_icons":"B_B_icons__5pA_m"};